import { createClient } from '@supabase/supabase-js';

const DEFAULT_SUPABASE_URL = 'https://onrsfovhmitumogakdjx.supabase.co';
const DEFAULT_SUPABASE_PUBLISHABLE_KEY = 'sb_publishable_2Uq-3lGmTTrXeaONtm725A_mCit2CPm';

const url = import.meta.env.VITE_SUPABASE_URL || DEFAULT_SUPABASE_URL;
const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || DEFAULT_SUPABASE_PUBLISHABLE_KEY;

/** Cliente Supabase browser. URL + publishable key son públicos; datos protegidos por Auth + RLS. */
export const supabase = createClient(url, publishableKey, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});
